// 注意顺序,会按照顺序执行每个对象的 init 方法
import Bars from './bars'
import User from './user'

const stores = { bars: Bars, user: User }

export default stores



// WEBPACK FOOTER //
// ./src/stores/index.js